import { useRef } from 'react';
import type { FieldHelperProps, FieldHookConfig, FieldInputProps, FieldMetaProps } from 'formik';
import { useField } from 'formik';

export function useFastField<Val = string | number | readonly string[] | undefined>(
  propsOrFieldName: string | FieldHookConfig<Val>
): readonly [FieldInputProps<Val>, FieldMetaProps<Val>, FieldHelperProps<Val>] {
  const [field, meta, helpers] = useField<Val>(propsOrFieldName);

  const actualHelpersRef = useRef<FieldHelperProps<Val>>(helpers);

  // On every render save newest helpers to actualHelpersRef
  actualHelpersRef.current.setValue = helpers.setValue;
  actualHelpersRef.current.setTouched = helpers.setTouched;
  actualHelpersRef.current.setError = helpers.setError;

  const consistentHelpersRef = useRef<FieldHelperProps<Val>>({
    setValue: (...args) => actualHelpersRef.current.setValue(...args),
    setTouched: (value: boolean, shouldValidate?: boolean) =>
      actualHelpersRef.current.setTouched(value, shouldValidate),
    setError: (...args) => actualHelpersRef.current.setError(...args)
  });

  return [field, meta, consistentHelpersRef.current] as const;
}
